<form *ngIf="fields && show.form" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="addEditForm" (ngSubmit)="saveOrUpdate()" RestrictFocus>

  <div class="ui-grid ui-grid-responsive ui-fluid">

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label [ngClass]="{'required': !fields.code.nullable}">{{ fields.code.keyName }}</label>
      </div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="code" pInputText [maxlength]="fields.code.width"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.code"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label [ngClass]="{'required': !fields.entity_id.nullable}">{{ fields.entity_id.keyName }}</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown [style]="{'width':'100%'}" formControlName="entity_id" [options]="entity_items" ></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.entity_id"></app-validation-msg>
      </div>
    </div>

  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0; margin-top: 15px;">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
                  [label]="editingElement.id ? ('common.edit' | translate) : ('supplierList.add_title' | translate)">
      </button>
    </div>
  </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/supplier/supplier-list/supplier-form.component.html